/**
 * API Configuration
 * 
 * This file contains configuration for API calls based on environment.
 * Uses environment variables set in .env files.
 */

// Base API URL from environment variables
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8899/api';

// Current environment
export const ENVIRONMENT = process.env.REACT_APP_ENV || 'development';

// Helper function to check current environment
export const isProduction = () => ENVIRONMENT === 'production';
export const isStaging = () => ENVIRONMENT === 'staging';
export const isDevelopment = () => ENVIRONMENT === 'development';

// Default API headers
export const getDefaultHeaders = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

// Logging configuration based on environment
export const shouldLogApiCalls = !isProduction();

// API request timeout (in milliseconds)
export const API_TIMEOUT = 120000; 